import { create } from 'zustand';

interface AgentUIStore {
  // Whether the agent is currently streaming/processing a request
  isAgentStreaming: boolean;
  setIsAgentStreaming: (isStreaming: boolean) => void;
}

export const useAgentUIStore = create<AgentUIStore>((set) => ({
  isAgentStreaming: false,
  setIsAgentStreaming: (isStreaming) => set({ isAgentStreaming: isStreaming }),
}));
